import React from 'react';
import ErrorBoundary from './components/error-boundary';
import FullPageSearch from './full-page-search';

function App() {
  const [query, setQuery] = React.useState('');
  React.useEffect(() => {
    const q = new URLSearchParams(window.location.search).get('q');
    setQuery(q);
  }, []);
  
  return (
    <div className="App">
      <ErrorBoundary>
        <FullPageSearch term={query} />
      </ErrorBoundary>
    </div>
  );
}

export default App;
